import theme from '../../../../../lib/theme';
import { IconContainerBlockProps } from './IconContainerBlock';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

interface IconSizes {
  small: string;
  medium: string;
  large: string;
}

const iconSizes: IconSizes = {
  small: '12',
  medium: '16',
  large: '25',
};

const gap = `1rem`;

export default ({
  block: { rounded_corners, icon_size },
}: IconContainerBlockProps) => ({
  container: {
    ...layouts.column,

    alignItems: 'center',
    padding: `${scale.s} ${scale.xs} ${scale.xl}`,
    gap: `${gap} !important`,
    fontFamily: families.primary,
  },
  iconsContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  icon: {
    flex: `0 0 calc(${iconSizes[icon_size]}% - ${gap})`,
    maxWidth: `${iconSizes[icon_size]}%`,

    [media.l.down]: {
      flex: `0 0 calc((${iconSizes[icon_size]}% * 2) - ${gap})`,
      maxWidth: `${iconSizes[icon_size] * 2}%`,
    },
    [media.s.down]: {
      flex: `0 0 calc(50% - ${gap})`,
      maxWidth: `50%`,
    },
  },
  bottomLine: {
    marginBottom: scale.s,
    marginTop: scale.s,
  },
  link: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: colors.dark_grey,
    textDecoration: 'underline',

    '&:hover': {
      textDecoration: 'none',
    },
  },
  iconImage: {
    marginBottom: scale.xxs,
    width: rounded_corners ? `70%` : `100%`,
    padding: rounded_corners ? `0.5rem` : `0`,
    maxWidth: `100%`,
    height: `auto`,
    borderRadius: rounded_corners ? `${rounded_corners}%` : 0,

    '& + p': {
      flexGrow: 0,
      textAlign: 'center',
    },
  },
});
